import { splitIOLocalhostFeatureFlags } from "../feature-flags/constants"
import { getSplitIOKey } from "./splitio-key"

export interface Config {
  splitIO: {
    core: {
      authorizationKey: string
      key: string
    }
    features:
      | {
          [key: string]: string
        }
      | undefined
    debug?: boolean
  }
}

const authorizationKey = process.env.REACT_APP_SPLIT_IO_AUTHORIZATION_KEY

export default (): Config => ({
  splitIO: {
    core: {
      authorizationKey: authorizationKey as string,
      key: getSplitIOKey()
    },
    features: authorizationKey === "localhost" ? splitIOLocalhostFeatureFlags : undefined,
    debug: authorizationKey === "localhost"
  }
})
